export const krDictionary = {
    lineup: "라인업",
    catchphrase: "좋아하는 아이템을 찾아보세요",
    guide: {
        title: "구매 전에",
        subtitle: "미리 확인하세요",
        what_is_service: "Web ROLL이란?",
        delivery: "배송 정보",
        qa: "자주 묻는 질문",
        contact: "문의하기",
        guide_to_signup: "처음 이용하는 분은 여기를 클릭하세요",
        login: "로그인",
        signup: "무료 회원 가입",
        link_login: "로그인은 여기",
        link_signup: "새로운 회원 등록은 여기",
        login_sns: "SNS로 간편 로그인",
        signup_sns: "SNS로 간편 등록",
        email_login: "이메일로 로그인",
        email_signup: "이메일로 회원 등록",
        google_login_support: "Google 로그인이 불가능한 고객께",
        login_form: {
            email: "이메일",
            password: "비밀번호",
            login_button: "이메일로 로그인",
            signup_button: "이메일로 회원 가입",
            agree: "동의합니다",
            forgot_password: "비밀번호를 잊으셨나요"
        },
        login_alert: {
            title: "회원으로 등록하면\nWeb ROLL을\n이용하실 수 있습니다",
            description: "SNS로 간편하게 등록하실 수 있습니다",
            login_button: "로그인",
            signup_button: "무료 회원 등록"
        }
    },
    gacha: {
        selling_status: {
            ended: "판매 종료",
            selling: {
                day: "{{value}}일 남음",
                hour: "{{value}}시간 남음",
                minute: "{{value}}분 남음",
                absolute: "( ~{{date}} 까지 )"
            },
            comingsoon: {
                day: "판매 시작 {{value}}일 전",
                hour: "판매 시작 {{value}}시간 전",
                minute: "판매 시작 {{value}}분 전",
                absolute: "( {{date}} 시작 예정 )"
            },
            play_limit: {
                reached_play_limit: "오늘의 구매 한도에 도달했습니다",
                remaining_play_limit: "오늘 남은 구매 가능 횟수: {{value}}회"
            },
        },
        description: {
            more: "더 보기",
            close: "닫기"
        }
    },
    gift_code: {
        input: {
            title: "기프트 코드 입력",
            cancel: "취소",
            scan_qr: "QR 코드 스캔",
            submit: "계정에 추가",
            code_placeholder: "여기에 기프트 코드 번호를 입력하세요",
            require_code_error: "기프트 코드를 입력해주세요",
            or: "또는"
        }
    },
    global: {
        header: {
            history: "구매 내역",
            menu: "메뉴",
            signup_or_login: "무료 회원가입 · 로그인",
            menus: {
                mypage: "마이페이지",
                logout: "로그아웃",
                login: "로그인",
                signup: "무료 회원가입",
                acquired_items: "획득한 아이템",
                input_code: "코드 입력",
                gift_code: "기프트 코드",
                play_ticket: "무료 티켓",
                prize_ticket: "티켓 / 쿠폰",
                user_id: "사용자 ID : {{id}}"
            }
        },
        footer: {
            company: "회사 소개",
            privacy: "개인정보 처리방침",
            terms: "이용 약관",
            contact: "문의하기",
            specified_commercial_transactions: "특정 상업 거래에 관한 표시"
        },
        login: {
            status: {
                google: "Google 계정으로 로그인 중",
                password: "이메일 주소로 로그인 중",
                unknown: "로그인 정보 없음"
            },
            success: "로그인 성공",
            error: {
                title: "로그인 실패",
                description: "문제가 계속되면 메뉴 > 문의하기에서 연락해주세요."
            }
        },
        signup: {
            error: {
                title: "회원가입에 실패했습니다",
                description: "문제가 계속되면 메뉴 > 문의하기에서 연락해주세요."
            }
        },
        common: {
            tax: {
                included: "세금 포함",
                excluded: "세금 별도"
            },
            piece: "회",
            sum: "합계",
            delivery_fee: "배송료",
            prize_unit: "개",
            remain_delivery_count: "남은 {{bundle_amount}} 개까지 무료배송입니다",
            jst_date_warning: "표시된 시간은 일본 표준시(JST)입니다",
            ok: "확인",
            cancel: "취소",
            register: "등록",
            company: "회사 소개",
            submit: "보내기",
            privacy: "개인정보 처리방침",
            terms: "이용 약관",
            contact: "문의하기",
            specified_commercial_transactions: "특정 상업 거래에 관한 표시"
        },
        adult_contents: {
            question_of_adulthood: {
                title: "당신은 18세 이상입니까?",
                description: "일반 작품뿐만 아니라, 폭력 및 성적 묘사 등 18세 미만자가 볼 수 없는 정보가 포함되어 있습니다."
            },
            contents_switch: {
                general: "일반 대상",
                adult: "성인용(R-18)"
            }
        }
    },
    components: {
        view_registered_address: "등록된 배송지 확인",
        shipping_forms: {
            country: "배송지 국가",
            name: "성명",
            phone: "전화번호",
            zip_code: "우편번호",
            email: "이메일 주소",
            full_address: "주소",
            prefecture: "도/도현",
            city: "시/군/구",
            address1: "번지",
            address2: "아파트·맨션 이름·방 번호",
            auto_fill: "주소 검색",
            errors: {
                is_required: "필수 항목입니다",
                address_auto_fill_not_in_service: "주소 검색은 일본 우편번호에만 사용 가능합니다",
                is_invalid_phone_number: "올바른 전화번호를 입력하세요",
                is_invalid_email: "올바른 이메일 주소를 입력하세요",
                is_invalid_zip_code: "3~9자리 범위로 입력하세요"
            }
        },
        shipments: {
            title: "배송 정보",
            about_bundle_capacity: "상품 【{{amount}}개】당",
            about_fee: "배송료에 대해",
            about_fee_detail: "▼배송료 상세 정보",
            period: "▼배송 시간 예상"
        },
        order_info: {
            play_ticket: "무료 티켓:",
            order_date: "주문일:",
            play_amount: {
                single: "{{amount}}회 뽑기",
                multi: "{{amount}}연속 뽑기"
            },
            payment_method: {
                label: "결제 방법:",
                no_info: "결제 정보 없음"
            },
            delivery: {
                title: {
                    delivery: "배송 현황:",
                    local_pickup: "픽업 현황:"
                },
                status: {
                    not_shipped: "미발송",
                    shipped: "발송 완료",
                    not_picked: "미수령",
                    picked: "수령 완료",
                    no_delivery: "배송하지 않는 설정의 주문입니다"
                }
            }
        }
    },
    pages: {
        gacha: {
            prizes: {
                about: "상품 정보",
                lineup: "상품 목록",
                view_collection: "획득한 아이템 보기"
            },
            purchase_benefits: "구매 특전",
            collection_items: "당첨 상품",
            collection: "컬렉션",
            "ticket/coupon": "티켓・쿠폰",
            guide_to_collection: "당첨된 디지털 콘텐츠・티켓・큐폰은 \"당첨 상품\"에서 확인할 수 있습니다",
            delivery: {
                price: "배송료",
                detail: "배송료 정보"
            },
            play: {
                single: "{{amount}}회 뽑기",
                multi: "{{amount}}연속 뽑기",
                single_lottery: "{{amount}}회 뽑기 시작",
                multi_lottery: "{{amount}}연속 뽑기 시작",
                button: "구매하기",
                view_play_buttons: "이 가차를 구매하기",
                has_play_ticket: "무료 티켓을 사용할 수 있습니다"
            },
            unplayable: {
                comingsoon: "곧 출시 예정",
                discontinued: "판매 종료",
                soldout: "품절",
                closing: "판매 중단 중"
            },
            result: {
                title: "뽑기 결과"
            }
        },
        onePass: {
            invalid_format: "올바른 형식으로 입력하세요",
            please_enter: "코드를 입력하세요",
            please_login: "로그인 후 이용하세요",
            send_error: "코드를 보내는 중 오류가 발생했습니다"
        },
        local_pickup: {
            qr_code_title: "수령 QR 코드",
            qr_code_description: "이 QR 코드를 현장 직원에게 제시하여 상품을 수령하세요",
            display_qr_code: "수령 QR 코드 표시",
            pickup_code: "코드: ",
            user_reference_number: "귀하의 참조 번호: ",
            calling_reference_number: "호출 중인 참조 번호: ",
            pickup_location: "수령 장소: ",
            pickup_location_detail: "수령 장소 상세 정보",
            local_pickup_description: "이 가챠는 현장 수령만 가능합니다",
            enter_prize_pickup: "수령 진행"
        },
        check_in: {
            title: "체크인",
            modal: {
                title: "이 가챠는 참석자 전용입니다",
                description: "장소에 도착하면 '체크인'을 탭하여 도착을 확인하세요",
                check_in_progress_1: "장소 근처에 있습니까,",
                check_in_progress_2: "확인 중..."
            },
            result: {
                success: "체크인 성공",
                not_nearby: {
                    title: "체크인 실패",
                    description: "장소 근처에서 다시 시도하세요"
                },
                permission_denied: {
                    title: "위치 정보 접근이 허용되지 않았습니다",
                    ios_description: "브라우저 설정 -> 웹사이트 설정 -> 위치 정보에서 허용을 선택한 후 다시 시도하세요",
                    android_description: "설정 앱을 실행하고, 앱 및 알림 -> 앱 및 알림 고급 설정 -> 앱 권한 -> 위치 정보에서 Chrome의 위치 정보를 켠 후 페이지를 다시 로드하고 다시 시도하세요"
                },
                get_location_failed: {
                    title: "위치 정보를 가져오는 데 실패했습니다",
                    description: "다시 시도하세요"
                }
            }
        },
        buy: {
            title: "배송지 정보 입력",
            submit_title: "구매하기",
            buy_again: "다시 구매하기",
            return_to_top: "TOP으로 돌아가기",
            cancel: "취소하기",
            check_warning: {
                title: "주의사항",
                form_title: "주의사항을 확인했습니다"
            },
            shippings: {
                title: "배송지 정보",
                different_address_warning: "배송지 정보를 변경하면 배송료가 발생합니다",
                cannot_ship_warning: "선택한 가차는 계정에 등록된 주소로 배송할 수 없습니다. 배송 가능한 주소를 입력해주세요.",
                forms: {
                    country: "배송지 국가",
                    name: "성명"
                },
                no: {
                    title: "당첨된 상품을 배송하지 않음",
                    description: "디지털 콘텐츠만 이용 가능합니다.",
                    warning: "당첨된 상품은 배송되지 않습니다. 주의하세요.",
                    confirm_title: "당첨된 상품을 배송하지 않아도 됩니까?",
                    confirm_description: "디지털 콘텐츠만 이용 가능합니다. 당첨된 상품을 배송 받고 싶지 않을 경우 이용하세요."
                }
            },
            payments: {
                title: "결제 방법",
                methods: {
                    credit: "신용카드",
                    paypay: "PayPay",
                    carrier: "통신사 결제",
                    unionpay: "UnionPay"
                },
                credit: {
                    title: "신용카드 정보",
                    cardno: "카드 번호",
                    exp: "유효 기간",
                    holder_name: "이름",
                    security_code: "보안 코드",
                    what_is_security_code: "보안 코드란",
                    quantity_full: "신용카드를 새로 등록하려면 등록된 카드를 삭제해주세요",
                    register_card: "신용카드 정보를 등록하기",
                    supported_card_text: "아래 카드사가 지원됩니다"
                },
                carrier: {
                    title: "통신사 결제 선택"
                },
                purchase_detail_description: {
                    credit: "※신용카드 내역에는 \"SWAMP STORE\"로 표시됩니다.\n\"SWAMP STORE\"는 이 서비스의 구매 내역입니다.",
                    app: "※앱 내역에는 \"SWAMP STORE\"로 표시됩니다.\n\"SWAMP STORE\"는 이 서비스의 구매 내역입니다."
                }
            },
            tipping_message: {
                title: "판매자에게 메시지 보내기",
                placeholder: "메시지를 입력하세요",
                invalid_length: "메시지가 너무 깁니다",
                caution: "이 메시지는 크리에이터의 라이브 스트리밍에 사용될 수 있으므로, 부적절한 내용을 입력하지 마세요."
            }
        },
        prize_ticket: {
            no_available_ticket: "사용 가능한 티켓/쿠폰이 없습니다",
            used_ticket: "사용한 티켓/쿠폰"
        },
        my_page: {
            title: "계정",
            nickname: {
                edit: "닉네임 수정",
                register: "닉네임 등록"
            },
            user_id: "사용자 ID",
            shipping_info: {
                title: "배송지 정보",
                register: "배송지 정보 등록",
                edit: "배송지 정보 수정"
            },
            delete_account: {
                title: "계정 삭제",
                modal: {
                    title: "계정을 삭제하시겠습니까?",
                    description: "계정을 삭제하면 등록된 개인 정보와 구매 내역이 모두 삭제되며, 구매한 디지털 콘텐츠에 대한 접근 및 다운로드가 불가능해집니다. 배송되지 않은 상품은 일반적인 배송 과정에 따라 배송됩니다.",
                    agree: "동의합니다",
                    confirm: "계정 삭제",
                    cancel: "취소",
                    success: {
                        title: "계정 삭제 성공",
                        description: "감사합니다"
                    },
                    error: {
                        title: "계정 삭제 실패",
                        description: "다시 로그인하고 다시 시도하세요"
                    }
                }
            }
        },
        history: {
            title: "구매 내역",
            no_history: "구매 내역이 없습니다",
            guide_to_collection: "당첨된 디지털 콘텐츠는 당첨 상품에서 확인할 수 있습니다",
            items_not_yet_received: "아직 수령하지 않은 상품",
            order_detail: {
                title: "주문 상세"
            }
        }
    },
    country: {
        JP: "일본",
        US: "미국",
        CN: "중국",
        KR: "한국",
        TW: "대만",
        HK: "홍콩"
    },
    errors: {
        "404": {
            title: "지정된 URL의 페이지가 존재하지 않습니다",
            description: "URL이 잘못되었거나 페이지가 삭제되었을 수 있습니다. 문제가 계속되면 계정 > 문의하기에서 연락해주세요."
        },
        "500": {
            title: "오류가 발생했습니다",
            description: "문제가 계속되면 메뉴 > 문의하기에서 연락해주세요."
        },
        not_found: {
            title: "페이지를 찾을 수 없습니다",
            description: "URL이 잘못되었거나 페이지가 삭제되었을 수 있습니다. 문제가 계속되면 계정 > 문의하기에서 연락해주세요."
        },
        failed: {
            check_in: "체크인에 실패했습니다.",
            get_gacha_detail: "이벤트 정보 획득에 실패했습니다.",
            get_gacha_history: "구매 내역을 불러오는 중 오류가 발생했습니다"
        }
    }
};
